module.exports = __webpack_public_path__ + "img/logo.ad5e8c7e.png";